import { ReactNode, createContext, useContext } from 'react';
import useBilling from '../hooks/useBilling';

type BillingContextData = ReturnType<typeof useBilling>;

const BillingContext = createContext<BillingContextData | null>(null);

const emptyBillingContextData: BillingContextData = {
  remainingCredits: 0,
  isLoading: false,
  plans: [],
  currentPlanId: null,
  changePackage: async () => {},
  isProPlan: null,
  isBillingLoading: false,
  isBillingError: false,
  creditsRefreshedAt: null,
  totalCredits: 0,
  currentPlan: null,
};

export const useBillingContext = () => {
  const context = useContext(BillingContext);
  return context || emptyBillingContextData;
};

interface BillingProviderProps {
  children: ReactNode;
}

export const BillingProvider = ({ children }: BillingProviderProps) => {
  const billing = useBilling();
  return <BillingContext.Provider value={billing}>{children}</BillingContext.Provider>;
};
